function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M16 6.9C16 9.11 14.21 10.9 12 10.9C9.79 10.9 8 9.11 8 6.9C8 4.69 9.79 2.9 12 2.9C14.21 2.9 16 4.69 16 6.9Z",
  id: "i2nA5R1uVD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.35 12.63C15.71 12.63 16 12.92 16 13.29C16 15.24 16 20.45 16 22.41C16 22.77 15.71 23.06 15.35 23.06C13.88 23.06 10.12 23.06 8.65 23.06C8.29 23.06 8 22.77 8 22.41C8 20.45 8 15.24 8 13.29C8 12.92 8.29 12.63 8.65 12.63C10.12 12.63 13.88 12.63 15.35 12.63Z",
  id: "cBpPrsaTF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.68 6.29C22.68 7.71 21.52 8.87 20.09 8.87C18.66 8.87 17.5 7.71 17.5 6.29C17.5 4.86 18.66 3.7 20.09 3.7C21.52 3.7 22.68 4.86 22.68 6.29Z",
  id: "c1YPHGL1CO"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.25 9.99C22.49 9.99 22.68 10.18 22.68 10.42C22.68 11.68 22.68 15.05 22.68 16.32C22.68 16.55 22.49 16.74 22.25 16.74C21.3 16.74 18.87 16.74 17.92 16.74C17.69 16.74 17.5 16.55 17.5 16.32C17.5 15.05 17.5 11.68 17.5 10.42C17.5 10.18 17.69 9.99 17.92 9.99C18.87 9.99 21.3 9.99 22.25 9.99Z",
  id: "b3MCokwbun"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.45 6.29C6.45 7.71 5.29 8.87 3.86 8.87C2.43 8.87 1.27 7.71 1.27 6.29C1.27 4.86 2.43 3.7 3.86 3.7C5.29 3.7 6.45 4.86 6.45 6.29Z",
  id: "a6cAjH8Kl"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.03 9.99C6.26 9.99 6.45 10.18 6.45 10.42C6.45 11.68 6.45 15.05 6.45 16.32C6.45 16.55 6.26 16.74 6.03 16.74C5.08 16.74 2.65 16.74 1.7 16.74C1.46 16.74 1.27 16.55 1.27 16.32C1.27 15.05 1.27 11.68 1.27 10.42C1.27 10.18 1.46 9.99 1.7 9.99C2.65 9.99 5.08 9.99 6.03 9.99Z",
  id: "c230CwrWXR"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#i2nA5R1uVD",
  opacity: 1,
  fill: "#0c0318",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#i2nA5R1uVD",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 1
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#cBpPrsaTF",
  opacity: 1,
  fill: "#0c0318",
  fillOpacity: 1
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c1YPHGL1CO",
  opacity: 1,
  fill: "#0c0318",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c1YPHGL1CO",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 1
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b3MCokwbun",
  opacity: 1,
  fill: "#0c0318",
  fillOpacity: 1
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a6cAjH8Kl",
  opacity: 1,
  fill: "#0c0318",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a6cAjH8Kl",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 1
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c230CwrWXR",
  opacity: 1,
  fill: "#0c0318",
  fillOpacity: 1
}))));

const SvgMultipleUsers = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMultipleUsers, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/multiple-users.581d6702.svg";
export { ForwardRef as ReactComponent };